import { render, staticRenderFns } from "./review-payment.vue?vue&type=template&id=15f08ca4&scoped=true&"
import script from "./review-payment.vue?vue&type=script&lang=js&"
export * from "./review-payment.vue?vue&type=script&lang=js&"
import style0 from "./review-payment.vue?vue&type=style&index=0&id=15f08ca4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f08ca4",
  null
  
)

export default component.exports